import Head from './components/Head';
import Projects from './components/Projects';
import About from './components/About';
import Achievements from './components/Achievements';
import Resume from './components/resume';
import Footer from './components/Footer';
import Loader from './components/loader';
import './App.css';
// import { Routes, Route } from "react-router-dom";
import React,{useEffect,useState} from 'react';

function App({ Name }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const timeout = setTimeout(() => {
      setLoading(false);
    }, 400);

    return () => clearTimeout(timeout); // Clear timeout on unmount
  }, [Name]);

  const renderComponent = () => {
    if (Name === "Head") {
      return <Head />;
    } else if (Name === "Projects") {
      return <Projects />;
    } else if (Name === 'About') {
      return <About />;
    } else if (Name === 'Achievements') {
      return <Achievements />;
    } else if (Name === 'Resume') {
      return <Resume />;
    } else if (Name === 'Footer') {
      return <Footer />;
    }
    return <Head/>;
  };


  return (
    <>
      {loading ? <Loader /> : renderComponent()}
    </>
  );
}


export default App;
